<template>
  <div class="flex h-full flex-row">
    <div class="flex flex-shrink-0 flex-col gap-y-4">
      <TheNewInvoicingNav />
    </div>
    <div class="mx-2 flex min-w-0 flex-1 flex-col gap-y-3">
      <DashboardMainContainer :type-dashboard="['payment']" />
    </div>
  </div>
</template>

<script>
import DashboardMainContainer from '@c/Dashboard/DashboardMainContainer.vue'
import BaseButton from "@c/addf-package/components/BaseButton/BaseButton.vue";
import InvoicingPanelControl from "@/views/invoicing/index/components/InvoicingPanelControl.vue";
import BaseTableComponent from "@c/BaseTableComponent.vue";
import TheNewInvoicingNav from "@/views/invoicing/components/TheNewInvoicingNav.vue";
import PaymentContent from "@c/Dashboard/Content/Payment/PaymentContent.vue";

export default {
  name: 'ThePaymentIndexPage',
  components: {
    TheNewInvoicingNav,
    DashboardMainContainer
  },
}
</script>

<style scoped></style>
